<template>
  <div class="store-user">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)" v-if="type">
      <el-form-item label="店铺">
        <el-input v-model="dataForm.storeName"></el-input>
      </el-form-item>
      <el-form-item label="区域">
        <el-select v-model="dataForm.districtId" placeholder="请选择">
          <el-option
            v-for="item in areaList"
            :key="item.districtId"
            :label="item.districtName"
            :value="item.districtId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList(1)">查询</el-button>
        <el-button @click="cleaList()">重置</el-button>
      </el-form-item>
    </el-form>

    <el-button type="primary" class="addBtn" @click="addOrUpdateHandle()">新建店铺</el-button>

    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%;" :header-cell-style="{background: '#eef1f6', color: '#606266', fontSize: '14px'}">
      <el-table-column prop="storeName" align="center" min-width="150" label="店铺名称"></el-table-column>
      <el-table-column prop="districtName" align="center" min-width="180" label="所属区域"></el-table-column>
      <el-table-column align="center" min-width="150" label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)">编辑</el-button> -->
          <el-button type="text" size="small" @click="deleteHandle(scope.row.storeId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <store-edit v-if="addOrUpdateVisible" ref="addOrUpdate" :areaList="areaList" @refreshDataList="getDataList"></store-edit>
  </div>
</template>

<script>
import storeEdit from "./comm/storeEdit";
import { storeList, storeDelete } from './api'
import { districtList } from '@/api/list'
export default {
  components: {
    storeEdit,
  },
  data() {
    return {
      dataForm: {
        storeName: "",
        districtId: ""
      },
      dataList: [{}],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      areaList: [],
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      type: ''
    };
  },
  mounted() {
    this.getDataList();
    this.getArea();
  },
  methods: {
    // 区域列表
    getArea() {
      districtList({ page: 1, limit: 1000 }).then(data => {
        if (data && data.code === 0) {
          this.areaList = data.page.list;
        } else {
          this.areaList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 获取店铺列表
    getDataList(page) {
      this.dataListLoading = true;
      // 判断组长和公司管理
      if(sessionStorage.getItem('isChairman')  == 'Y'){
        this.type = true;
      }else if(sessionStorage.getItem('isLeader')  == 'Y') {
        this.type = false;
      };
      storeList({
        page: page ||this.pageIndex,
        limit: this.pageSize,
        districtId: this.dataForm.districtId || null,
        storeName: this.dataForm.storeName  || null
      }).then(data => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
          this.$message.error(data.msg);
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(data) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(data);
      });
    },
    // 重置
    cleaList() {
      this.dataForm = {};
      this.pageIndex = 1;
      this.getDataList();
    },
    // 删除
    deleteHandle(id) {
      let that = this
      let storeId = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.userId;
          });
      this.$confirm(
        `确定进行删除操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
         storeDelete(storeId).then(data => {
            if (data && data.code === 0) {
              that.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  that.getDataList();
                },
              });
            } else {
              that.$message.error(data.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.addBtn {
  margin-bottom: 20px;
}
</style>